import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-plant-line text-lg" aria-hidden="true" />
          </span>
          <span className="font-heading text-lg font-semibold tracking-tight text-foreground-950">
            香蕉社区
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="站内导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#share"
            className="whitespace-nowrap rounded-md px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
          >
            看看分享
          </a>
          <a
            href="#benefits"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            加入社区
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#benefits"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
          >
            加入社区
          </a>
        </div>
      ) : null}
    </header>
  );
}